import { useCallback } from "react";

import useCommandPaletteStore from "../store/useCommandPaletteStore";
import useCommandPaletteRecentActionsStore from "../store/useRecentActionsStore";
import { CommandPaletteActionType, type CommandPaletteAction } from "../types";
import { makeRecentActionId } from "../utils/ids";

const useCommandPaletteExecuteAction = () => {
  const setModalOpen = useCommandPaletteStore((state) => state.setModalOpen);
  const trackActionUsage = useCommandPaletteRecentActionsStore((state) => state.trackActionUsage);

  return useCallback(
    (action: CommandPaletteAction) => {
      action.onAction();

      const isSubListOpener = action.type === CommandPaletteActionType.SUB_LIST_OPENER;

      if (!isSubListOpener) {
        trackActionUsage({
          ...action,
          id: makeRecentActionId(action.id),
        });
      }

      const shouldKeepOpen = "keepModalOpen" in action && action.keepModalOpen;

      if (!isSubListOpener && !shouldKeepOpen) {
        setModalOpen(false);
      }
    },
    [setModalOpen, trackActionUsage]
  );
};

export default useCommandPaletteExecuteAction;
